import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: '2xl',
    fontFamily: 'Chewy',
    textShadow: '0px 1px 4px rgba(0, 0, 0, 0.50)',
    color: 'gamma.400',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    px: ['2.5', null, null, '3'],
    py: '2',
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  boxSportWrapper: {
    border: '1px',
    borderColor: 'beta.300',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '2',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'md',
    gap: '1',
    color: 'gamma.400',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  headingIcon: {
    color: 'gamma.400',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  buttonSport: {
    h: '26px',
    borderColor: 'beta.300',
    _hover: {
      color: 'gamma.400',
    },
  },
  buttonAllSports: {
    h: '26px',
    color: 'white',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'beta.300',
    _hover: {
      color: 'gamma.400',
    },
    _active: {
      color: 'gamma.800',
      border: 'none',
      bgGradient: 'linear(to-b, gamma.400, gamma.500)',
    },
  },
};
